module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-2-18f3646a977af449b9b8fc46c0ca34ad.png";